<script setup lang="ts">

import type NewsItem from "@/types/NewsItem.ts";
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import PlayerName from '@/components/Objects/PlayerName.vue'
import { usePlayerRelationStore } from '@/stores/playerRelations.ts'
import { useGameStore } from '@/stores/gameStore.ts'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const playerRelationStore = usePlayerRelationStore();
const gameStore = useGameStore();

/**
 * Props
 */
const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

/**
 * Computed
 */
const playerImage = computed(() => {
  return playerRelationStore.getProfileImageByPlayerId(props.newsItem.contentData.playerId);
});

</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="playerImage"
    :toast-text="t('news.types.spyDetected.title')"
  >
    <NewsItemBaseStructure
      :newsItem="props.newsItem"
      :item-image="playerImage"
      :header="t('news.types.spyDetected.title')"
    >
      <PlayerName :player-id="props.newsItem.contentData.playerId" /> {{ t('news.types.spyDetected.body', { mission: t(`diplomacy.spies.missions.${props.newsItem.contentData.mission}.name`) }) }}
      <span v-if="gameStore.combatMode === 'RC'" class="text-red-500 block mt-2">
        {{ t('news.types.spyDetected.note') }}
      </span>
    </NewsItemBaseStructure>
  </NewsItemBase>
</template>

<style scoped lang="scss">

</style>